
let header = document.querySelector(".header");
let burger = document.querySelector(".header__burger");
let menu = document.querySelector(".menu");

burger.addEventListener("click", function() {
    this.classList.toggle("header__burger_active");
    header.classList.toggle("dark");
    menu.classList.toggle("active");
    document.querySelector("body").classList.toggle("lock");
})

  
 
    $(".menu-item__title").click(function() {
        if (window.innerWidth <= 768) {
            $(this).toggleClass("active").next().slideToggle(300);
        } 
    })
